type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue: unknown[][]
  push: MetaPixel
  loaded: boolean
  version: string
}

declare global {
  interface Window {
    fbq?: MetaPixel
    _fbq?: MetaPixel
    __metaPixelPageViewTracked?: boolean
    __metaPixelInitializedIds?: string[]
  }
}

// Every Meta Pixel installed on this page. Each ID is initialized once,
// and a single PageView call is delivered to all of them.
export const META_PIXEL_IDS = ['1005998559190017']

const SCRIPT_SRC = 'https://connect.facebook.net/en_US/fbevents.js'

function ensureBaseCode(): MetaPixel {
  if (window.fbq) return window.fbq

  // Official Meta Pixel base code stub (queues calls until fbevents.js loads).
  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) fbq.callMethod(...args)
    else fbq.queue.push(args)
  } as MetaPixel
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []
  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq

  if (!document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
    const script = document.createElement('script')
    script.async = true
    script.src = SCRIPT_SRC
    const firstScript = document.getElementsByTagName('script')[0]
    if (firstScript?.parentNode) firstScript.parentNode.insertBefore(script, firstScript)
    else document.head.appendChild(script)
  }

  return fbq
}

export function initMetaPixels() {
  if (typeof window === 'undefined') return
  const fbq = ensureBaseCode()

  const initialized = (window.__metaPixelInitializedIds ??= [])
  for (const id of META_PIXEL_IDS) {
    if (initialized.includes(id)) continue
    // Disable Meta's automatic event detection (button-click inference) for this pixel.
    // Must run before 'init'. Does not affect the explicit PageView below.
    fbq('set', 'autoConfig', false, id)
    fbq('init', id)
    initialized.push(id)
  }

  if (window.__metaPixelPageViewTracked) return
  window.__metaPixelPageViewTracked = true
  fbq('track', 'PageView')
}
